import { useMemo } from 'react';
import { Entity } from '@backstage/catalog-model';
import { DB_SCHEMA_ANNOTATION } from './db-explorer.types';
import type { DbSchemaAnnotation, DbSchemaResponse } from './db-explorer.types';

interface UseSchemaResult {
  schema: DbSchemaResponse | null;
  tableCount: number;
  fkCount: number;
}

export function useSchema(entity: Entity, selectedEnv: string | null): UseSchemaResult {
  const schemaAnnotation = useMemo(() => {
    const raw = entity.metadata.annotations?.[DB_SCHEMA_ANNOTATION];
    if (!raw) return null;
    try {
      return JSON.parse(raw) as DbSchemaAnnotation;
    } catch {
      return null;
    }
  }, [entity]);

  const schema = useMemo(() => {
    if (!schemaAnnotation || !selectedEnv) return null;
    const envSchema = schemaAnnotation[selectedEnv];
    if (!envSchema) return null;
    return { tables: envSchema.tables, foreignKeys: envSchema.foreignKeys };
  }, [schemaAnnotation, selectedEnv]);

  return {
    schema,
    tableCount: schema?.tables.length ?? 0,
    fkCount: schema?.foreignKeys.length ?? 0,
  };
}
